module.exports = __webpack_public_path__ + "static/category-shirt-93dad2d4080430980cfc395f53c2e2b5.jpg";